export const categories = [
  {
    slug: 'techniques',
    name: '乳交技巧',
    description: '从基础到进阶的乳交技巧全解析，帮助你掌握正确的方法与节奏',
    icon: 'ri-lightbulb-line',
    color: 'accent',
  },
  {
    slug: 'positions',
    name: '乳交体位',
    description: '推荐多种舒适且刺激的体位，找到最适合你们的姿势',
    icon: 'ri-layout-grid-line',
    color: 'primary',
  },
  {
    slug: 'feelings',
    name: '乳交感受',
    description: '从双方视角深度解读乳交中的身体与心理体验',
    icon: 'ri-heart-pulse-line',
    color: 'secondary',
  },
  {
    slug: 'safety',
    name: '注意事项',
    description: '安全第一，了解乳交中需要注意的卫生、力度与沟通要点',
    icon: 'ri-shield-check-line',
    color: 'secondary',
  },
];